module.exports = "/images/calendar.svg?6d5caebd85df28a467dec04ad9f07385";